<template>
  <div id='ClientPage' class="fit q-px-md">
    <div class="text-right col-3">
      <q-btn flat @click="backToSearch()" no-caps>
        <q-icon name="reply" /> <translate>BACK_TO_SEARCH</translate>
      </q-btn>
    </div>
    <q-card-section class="row client-title">
      <div class="col-9">
        <span class="text-h6 text-bold">{{ $gettext("CUSTOMER") }}:&nbsp;</span>
        <span class="text-h6 text-light"
          >{{ this.id }}&nbsp;|&nbsp;{{ name }}</span
        >
      </div>
    </q-card-section>
    <div class="row no-padding " :class="{'menu-grid': clientMeasuementHeightCss}" >
      <q-card class="col-2 q-ma-md q-py-sm" v-if="menus">
        <q-list class="buttons-list">
          <q-item
            v-for="item in menus"
            :key="item"
            clickable
            v-ripple
            :active="item.name === pageData.name"
            @click="changeClientPageSelect(item)"
            active-class="itemSelect"
            class="item q-pa-md"
            :data-testId="item.name"
          >
            <q-item-section avatar>
              <q-icon
                :color="item.name === pageData.name ? 'negative' : 'secondary'"
                :name="item.icon"
              />
            </q-item-section>
            <q-item-section class="ellipsis">
              {{ $gettext(item.name) }}</q-item-section
            >
          </q-item>
        </q-list>
      </q-card>
      <q-card class="col-9 q-ma-md no-padding" v-if="pageData.name">
        <div class="title-card-client">
          <span class="text-h6">{{ $gettext(pageData.title) }}</span>
        </div>
        <component
          :id="pageData.id"
          :is="pageData.component"
          :name="pageData.name"
          :params="pageData.params"
          :forms="pageData.forms"
          :datatable="pageData.datatable"
          :parent="pageData.parent"
          :nmInterface="pageData.interface"
          :interface="pageData.interface"
          :controllerSearch="true"
          :clientId="id"
          @action-button="actionButton"
          @show-message="showMessage"
          class="client-container generator-client"
          clean-layout
        />
      </q-card>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository, messageBox } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
import { menu } from './client.config'

const { CrudLayout } = JtCrud

@Component({
  name: 'ClientPage',
  components: {
    CrudLayout
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ClientPage extends Vue {
  pageData = {};
  updateButton = 'btAlterar';
  clientMeasuementHeightCss = false;
  get params () {
    return {
      id: this.id
    }
  }

  get menus () {
    return menu
  }

  beforeMount () {
    this.changeClientPageSelect(this.menus[0])
  }

  async changeClientPageSelect (item) {
    const pageData = {}
    pageData.crud = item.crud
    if (!pageData.crud) {
      const forms = await repository.resolve(item.interface, this.params)
      pageData.forms = forms
    }
    pageData.component = item.component
    pageData.name = item.name
    pageData.id = item.name
    pageData.interface = item.interface
    pageData.params = {
      name: item.name,
      client: this.id
    }
    pageData.datatable = null
    pageData.title = item.title
    this.pageData = pageData
    if (item.name == 'MEASUREMENTS') {
      pageData.id = this.id
      this.clientMeasuementHeightCss = true
    } else {
      this.clientMeasuementHeightCss = false
    }
  }

  async actionButton (button, params, page) {
    switch (button.name) {
      case this.updateButton:
        await repository.update(button.action, { ...params, id: this.id })
        break
    }
  }

  showMessage (type, message, page) {
    messageBox.warn(this.$gettext(message))
  }

  backToSearch () {
    this.$router.push({
      name: 'client',
      params: {
        id: 'client',
        interface: 'client.pesquisar',
        link: 'client',
        reload: true
      },
      force: true,
      reload: true
    })
  }
}
export default ClientPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

#ClientPage {

  .menu-grid{
    height: calc(88vh - 10px) !important;
  }

  .text-light {
    font-weight: 400;
  }

  .crud-title {
    display: none;
  }

  .client-container {
    height: calc(75vh - 10px) !important;
    box-shadow: none !important;
    background: transparent !important;
  }

  .container-crud {
    .q-card {
      box-shadow: none !important;
    }

    .dynamic-form #scroll-area {
      height: calc(60vh - 0px);
    }
  }

  .client-title {
    padding: 20px 20px 0px;
  }

  .title-card-client {
    padding: 10px 0px 0px;
    margin: 0px 15px;
    border-bottom: 0.3px solid $faded !important;
  }

  .container-crud > .q-card {
    box-shadow: none !important;
    background: transparent !important;
  }

  ::v-deep {
    .jt-crud-container {
      padding: 0%;
    }
  }

  .padding-crud {
    padding: 0px 10px 10px;
    margin-top: -15px;
  }

  .itemSelect {
    background: $amber !important;
    padding: 6.5% 15%;
    border-left: 5px solid $dark !important;
  }

  .item {
    font-weight: 500;
    padding: 6.5% 12%;
    font-size: 1rem;
    border-top: 0.3px solid $faded !important;
  }

  .q-item__section--avatar {
    min-width: 43px;
  }
}

@media only screen and (max-height: 790px) {
  #ClientPage {
    .client-title {
      padding: 15px 20px 0px;
    }
  }
}
</style>
